module.exports = __webpack_public_path__ + "c710301305b072d679dfae2e5b78f825.jpg";